import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Link } from "react-router-dom";
import { typeBadge } from "@/lib/ticketTypes";

const DRINK_LABEL = { SOFT_DRINK: "Soft Drink", BEER: "Beer", COCKTAIL: "Cocktail" };

export default function Purchases() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/purchases", { params: { limit: 500 } }).then((r) => setItems(r.data.items)); }, []);

  return (
    <div className="space-y-6">
      <div>
        <div className="text-xs tracking-[0.3em] uppercase text-orange-400 font-bold">Sales</div>
        <h1 className="font-display text-4xl sm:text-5xl font-black text-white tracking-tight">ADDITIONAL DRINK SALES</h1>
      </div>
      <div className="bg-[#131D33] border border-slate-800 rounded-2xl overflow-hidden">
        <div className="hidden md:grid grid-cols-12 px-4 py-3 text-xs uppercase tracking-widest text-slate-400 border-b border-slate-800 bg-black/20">
          <div className="col-span-2">Time</div>
          <div className="col-span-2">Ticket</div>
          <div className="col-span-2">Type</div>
          <div className="col-span-2">Drink × Qty</div>
          <div className="col-span-1">Pay</div>
          <div className="col-span-2">Registration</div>
          <div className="col-span-1 text-right">New Bal.</div>
        </div>
        <div className="divide-y divide-slate-800">
          {items.length === 0 && <div className="p-10 text-center text-slate-500">No additional drink sales yet.</div>}
          {items.map((p) => (
            <Link to={`/tickets/${p.ticket_id}`} key={p.id} className="grid grid-cols-2 md:grid-cols-12 px-4 py-3 hover:bg-white/5" data-testid={`purchase-${p.id}`}>
              <div className="md:col-span-2 text-slate-400 text-sm">{new Date(p.created_at).toLocaleString()}</div>
              <div className="md:col-span-2 font-mono-fb text-orange-300">{p.ticket_visible}</div>
              <div className="md:col-span-2">
                <span className={`inline-block px-2 py-0.5 text-xs font-bold rounded ${typeBadge(p.ticket_type)}`}>{p.ticket_type}</span>
              </div>
              <div className="md:col-span-2 text-white font-semibold">{DRINK_LABEL[p.drink_type]} × {p.quantity}</div>
              <div className="md:col-span-1">
                <span className={`inline-block px-2 py-0.5 text-xs font-bold rounded ${p.payment_method === "CASH" ? "bg-emerald-500/20 text-emerald-300" : "bg-sky-500/20 text-sky-300"}`}>{p.payment_method}</span>
                {p.payment_source === "GUEST_SELF_SERVICE" && <span className="block mt-1 text-[10px] font-bold text-amber-300" data-testid={`purchase-self-service-${p.id}`}>SELF-SERVICE / STRIPE</span>}
              </div>
              <div className="md:col-span-2 text-slate-400 text-sm truncate">{p.created_by_email}</div>
              <div className="md:col-span-1 text-right font-bold text-teal-300">{p.new_balance}</div>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
}
